import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBadgeGreen = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 8,
	viewBox: "0 0 8 8",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("circle", {
		cx: 4,
		cy: 4,
		r: 4,
		fill: "#659C41"
	})]
});
const ForwardRef = forwardRef(SvgBadgeGreen);
export { ForwardRef as ReactComponent };
